import Component from '../core/Component'
import Nette from '../nette/NetteForms'
import { queryAll } from '../utils/dom'
import { scrollToElement } from '../services/Scroll'
import { formatCurrency } from '../utils/Number'

const STATES = {
    COLLAPSED: 'is-collapsed'
}

const defaults = {
    basePrice: 0
}

export default class FormOrder extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            intro: null,
            data: null,
            buttonContinue: null,
            priceRegions: [],
            subserviceToggles: [],
            subservice: null
        }
    }
    prepare() {
        this.ref.intro.addEventListener('change', this.handleIntroChange)
        this.ref.intro.addEventListener('input', this.handleIntroInput)
        this.ref.buttonContinue.addEventListener('click', this.handleContinueClick)
        this.ref.data.addEventListener('transitionEnd', this.handleDataTransitionEnd)
        this.ref.subserviceToggles.forEach(element => element.addEventListener('change', this.handleSubserviceChange))

        this.priceRegions = this.ref.priceRegions.map(element => Component.getFromElement(element))
        this.priceRegions.forEach(region => region.on('change', this.handlePriceRegionChange))

        setTimeout(() => this.check(), 0)
    }

    handleSubserviceChange = event => {
        if (event.target.value === '0') {
            this.resetSubservice()
        }
    }

    handlePriceRegionChange = () => {
        this.calculate()
    }

    handleIntroChange = event => {
        this.check()
    }

    handleIntroInput = event => {
        if (event.target.type === 'radio' || event.target.type === 'checkbox') {
            return
        }
    }

    handleContinueClick = event => {
        event.preventDefault()
        this.expand()
    }

    handleDataTransitionEnd = event => {
        if (event.target === this.ref.data) {
            this.ref.data.classList.remove('is-collapsed')
            this.ref.data.removeAttribute('height')
            this.ref.data.removeEventListener('transitionEnd', this.handleDataTransitionEnd)
        }
    }

    check() {
        const isValid = !queryAll('input, select, textarea', this.ref.intro)
            .map(element => Nette.validateControl(element, null, true))
            .some(result => !result)

        this.ref.buttonContinue.disabled = !isValid

        this.calculate()
    }

    calculate() {
        const total = this.priceRegions.reduce((acc, region) => acc + region.price, this.options.basePrice)
        this.update(total)
    }

    update(price) {
        queryAll('[data-ref="total"]', this.element).forEach(element => element.textContent = formatCurrency(price))
    }

    expand() {
        if (this.ref.data.classList.contains(STATES.COLLAPSED)) {
            this.ref.data.style.height = `${this.ref.data.scrollHeight}px`
        }

        scrollToElement(this.ref.data)

        this.ref.intro.removeEventListener('change', this.handleIntroChange)
        this.ref.intro.removeEventListener('input', this.handleIntroChange)
    }

    resetSubservice() {
        queryAll('[data-ref="FormOrder:priceRegion', this.ref.subservice)
            .map(element => Component.getFromElement(element))
            .forEach(region => region.reset())

        this.calculate()
    }
}
